import * as Tabs from "@radix-ui/react-tabs";
import { FileText, Info, Bell } from "lucide-react";

const ContentTabs = () => {
  return (
    <Tabs.Root defaultValue="about" className="w-full">
      <Tabs.List className="w-full justify-start bg-white border border-border/50 p-1 rounded-lg flex">
        <Tabs.Trigger
          value="about"
          className="flex items-center gap-2 px-3 py-1 rounded-md "
        >
          <Info size={16} />
          About
        </Tabs.Trigger>

        <Tabs.Trigger
          value="documents"
          className="flex items-center gap-2 px-3 py-1 rounded-md "
        >
          <FileText size={16} />
          Documents
        </Tabs.Trigger>

        <Tabs.Trigger
          value="updates"
          className="flex items-center gap-2 px-3 py-1 rounded-md "
        >
          <Bell size={16} />
          Updates
        </Tabs.Trigger>
      </Tabs.List>

      <Tabs.Content value="about" className="mt-4 animate-fade-up">
        <div className="card-elevated p-6">
          <h3 className="text-xl font-heading font-semibold mb-4">
            About This Campaign
          </h3>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Our mission is to provide essential resources and support to communities in need.
            This campaign focuses on delivering clean water, educational materials, and healthcare
            supplies to underserved regions.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Every donation makes a difference. With your help, we can reach more families and
            create lasting positive change in their lives.
          </p>
        </div>
      </Tabs.Content>

      <Tabs.Content value="documents" className="mt-4 animate-fade-up">
        <div className="card-elevated p-6">
          <h3 className="text-xl font-heading font-semibold mb-4">
            Campaign Documents
          </h3>
          <ul className="space-y-3">
            {[
              "Annual Report 2024.pdf",
              "Financial Statement Q3.pdf",
              "Impact Assessment.pdf",
              "Volunteer Guidelines.pdf",
            ].map((doc, index) => (
              <li
                key={index}
                className="flex items-center gap-3 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors cursor-pointer"
              >
                <FileText size={20} className="text-primary" />
                <span className="text-foreground">{doc}</span>
              </li>
            ))}
          </ul>
        </div>
      </Tabs.Content>

      <Tabs.Content value="updates" className="mt-4 animate-fade-up">
        <div className="card-elevated p-6">
          <h3 className="text-xl font-heading font-semibold mb-4">
            Recent Updates
          </h3>
          <div className="space-y-4">
            {[
              { date: "Dec 8, 2024", title: "Milestone Reached!", text: "We've reached 75% of our goal!" },
              { date: "Dec 5, 2024", title: "New Partnership", text: "Partnered with Global Aid Foundation." },
              { date: "Dec 1, 2024", title: "Campaign Launch", text: "Our winter campaign is now live!" },
            ].map((update, index) => (
              <div
                key={index}
                className="p-4 rounded-lg bg-muted/50 border-l-4 border-primary"
              >
                <span className="text-xs text-muted-foreground">
                  {update.date}
                </span>
                <h4 className="font-semibold text-foreground mt-1">
                  {update.title}
                </h4>
                <p className="text-sm text-muted-foreground mt-1">
                  {update.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Tabs.Content>
    </Tabs.Root>
  );
};

export default ContentTabs;
